import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ModelSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { ViewSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/view";

const modulfTitle = "MODUL-F FV-Portal";

/**
 * A custom middleware to set the (HTML) document title to the current "menu
 * location" in the form "ModuleTitle - MODUL-F FV-Portal"
 */
export const documentTitleMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	const result = next(action);
	const nextState = api.getState();
	const topLevelActivity = Object.values(ActivitySelectors.topLevelActivities()(nextState))[0];

	if (topLevelActivity !== undefined) {
		const sceneRef = ViewSelectors.sceneReferenceByActivityId(topLevelActivity.id)(nextState);
		if (sceneRef !== undefined) {
			const appModel = ModelSelectors.applicationModel()(nextState);

			const module = appModel.content.modules.find(m => m.name === sceneRef.moduleName);
			const moduleLabel = module?.menu?.label?.find(it => it.locale === "de")?.text;

			setTitle(moduleLabel ? `${moduleLabel} - ${modulfTitle}` : modulfTitle);
		}
	} else {
		setTitle(modulfTitle);
	}
	return result;
});

function setTitle(title: string): void {
	if (document.title !== title) {
		document.title = title;
	}
}
